import { useState } from "react";
import { api, money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export function OrderShippingInfo({ o, onChanged }) {
  const si = o.shipping_info;
  const [amt, setAmt] = useState("");
  const [note, setNote] = useState("");
  if (!si) return null;
  const fq = si.freight_quote || {};
  const send = async () => {
    try { await api.post(`/admin/shipping/orders/${o.order_number}/freight-quote`, { amount: Number(amt), note, origin_url: window.location.origin }); toast.success("Freight quote emailed to the customer"); onChanged && onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not send quote"); }
  };
  return (
    <div className="mt-3 rounded-lg border p-3 text-xs space-y-1" data-testid={`order-shipping-${o.order_number}`}>
      <p><b>Shipping:</b> {si.method} · {si.zone || (si.island ? `${si.island} island` : "")}{si.rural ? " · Rural" : ""} · {si.classification}</p>
      {(si.breakdown || []).map((b, i) => <p key={i} className="text-muted-foreground">{b.label}: {b.pending ? "quote pending" : money(b.amount)}</p>)}
      {si.status === "quote_pending" && (
        <div className="pt-2 space-y-2">
          <p className="font-semibold text-red-700">Freight quote: {fq.status || "awaiting your quote"}{fq.amount != null && ` · ${money(fq.amount)}`} — dispatch is blocked until the customer approves.</p>
          {(!fq.status || fq.status === "declined") && (
            <div className="flex flex-wrap gap-2">
              <Input type="number" min="0" placeholder="Freight $ incl GST" value={amt} onChange={(e) => setAmt(e.target.value)} className="h-8 w-40" data-testid={`freight-amount-${o.order_number}`} />
              <Input placeholder="Note to customer (optional)" value={note} onChange={(e) => setNote(e.target.value)} className="h-8 flex-1 min-w-[160px]" />
              <Button size="sm" className="h-8 bg-accent text-steel" disabled={amt === ""} onClick={send} data-testid={`freight-send-${o.order_number}`}>Send quote</Button>
            </div>
          )}
        </div>
      )}
      {fq.status === "approved" && <p className="font-semibold text-emerald-700">Freight {money(fq.amount)} approved by customer.</p>}
    </div>
  );
}
